import * as actions from '../../actions/types';

const INITIAL_STATE = {
    vendorProjectPhotos: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    },
    vendorProjectStagePhotos: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    },
};

const vendorPhotosReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_VENDOR_PHOTOS_DETAIL_LOADING:
            return {
                ...state,
                vendorProjectPhotos: {
                    ...state.vendorProjectPhotos,
                    get: {
                        ...state.vendorProjectPhotos.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.vendorProjectPhotos.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_VENDOR_PHOTOS_DETAIL_SUCCESS:
            return {
                ...state,
                vendorProjectPhotos: {
                    ...state.vendorProjectPhotos,
                    get: {
                        ...state.vendorProjectPhotos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.vendorProjectPhotos.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_VENDOR_PHOTOS_DETAIL_FAILURE:
            return {
                ...state,
                vendorProjectPhotos: {
                    ...state.vendorProjectPhotos,
                    get: {
                        ...state.vendorProjectPhotos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.vendorProjectPhotos.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case actions.GET_VENDOR_PHOTOS_DETAIL_RESET:
            return {
                ...state,
                vendorProjectPhotos: {
                    ...state.vendorProjectPhotos.get,
                    post: {
                        ...INITIAL_STATE.vendorProjectPhotos.get,
                        reset: true,
                    },
                },
            }
        case actions.GET_VENDOR_STAGE_PHOTOS_LOADING:
            return {
                ...state,
                vendorProjectStagePhotos: {
                    ...state.vendorProjectStagePhotos,
                    get: {
                        ...state.vendorProjectStagePhotos.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.vendorProjectStagePhotos.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_VENDOR_STAGE_PHOTOS_SUCCESS:
            return {
                ...state,
                vendorProjectStagePhotos: {
                    ...state.vendorProjectStagePhotos,
                    get: {
                        ...state.vendorProjectStagePhotos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.vendorProjectStagePhotos.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_VENDOR_STAGE_PHOTOS_FAILURE:
            return {
                ...state,
                vendorProjectStagePhotos: {
                    ...state.vendorProjectStagePhotos,
                    get: {
                        ...state.vendorProjectStagePhotos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.vendorProjectStagePhotos.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case actions.GET_VENDOR_STAGE_PHOTOS_RESET:
            return {
                ...state,
                vendorProjectStagePhotos: {
                    ...state.vendorProjectStagePhotos.get,
                    post: {
                        ...INITIAL_STATE.vendorProjectStagePhotos.get,
                        reset: true,
                    },
                },
            }
    }
    return state;
}

export default vendorPhotosReducers;
